// signInReducer.js
const initialState = {
  //memberList: [], // Default value
  // selectedMemberList: [],
  //serviceList: [],
  //assignList: [],
  //managerList: [],
  //supervisorList: [],
  usernameError: false,
  usernameErrorMessage: '',
  passwordError: false,
  passwordErrorMessage: '',
  username: '',
  password: '',
  loading4SignIn: false,
  credential: '',  
};

export default function signInReducer(state = initialState, action) {
  switch (action.type) {
    case 'setCredential':
      return {
        ...state,
        credential: action.payload,
      };      
    case 'setUsernameError':
      return {
        ...state,
        usernameError: action.payload,
      };
    case 'setUsernameErrorMessage':
      return {
        ...state,
        usernameErrorMessage: action.payload,
      };     
    case 'setPasswordError':
      return {
        ...state,
        passwordError: action.payload,
      };  
    case 'setPasswordErrorMessage':
      return {
        ...state,
        passwordErrorMessage: action.payload,
      };  
    case 'setPassword':
      return {
        ...state,
        password: action.payload, // Update the selected book
      };       
    case 'setUsername':
      return {
        ...state,
        username: action.payload, // Update the selected book
      };     
    // case 'setSupervisorList':
    //   return {
    //     ...state,
    //     supervisorList: action.payload, // Update the selected book
    //   };     
    // case 'setManagerList':
    //   return {
    //     ...state,
    //     managerList: action.payload, // Update the selected book
    //   };    
    // case 'setMemberList':
    //   return {
    //     ...state,
    //     memberList: action.payload, // Update the selected book
    //   };
    // case 'setSelectedMemberList':
    //   return {
    //     ...state,
    //     selectedMemberList: action.payload, // Update the selected book
    //   };  
    // case 'setServiceList':
    //   return {
    //     ...state,
    //     serviceList: action.payload, // Update the selected book
    //   };     
    // case 'setAssignList':
    //   return {
    //     ...state,
    //     assignList: action.payload, // Update the selected book
    //   };            
    case 'reset4SignIn':
      return initialState;     
    default:
      return state;
  }
}
export const setCredential = (e) => ({
  type: 'setCredential',
  payload: e,
});

export const setUsernameError = (e) => ({
  type: 'setUsernameError',
  payload: e,
});

export const setUsernameErrorMessage = (e) => ({
  type: 'setUsernameErrorMessage',
  payload: e,
});

export const setPasswordError  = (e) => ({
  type: 'setPasswordError',
  payload: e,
});

export const setPasswordErrorMessage  = (e) => ({
  type: 'setPasswordErrorMessage',
  payload: e,
});

export const setPassword = (e) => ({
  type: 'setPassword',
  payload: e,
});

export const setUsername = (e) => ({
  type: 'setUsername',
  payload: e,
});

// export const setSupervisorList = (e) => ({
//   type: 'setSupervisorList',
//   payload: e,
// });

// export const setManagerList = (e) => ({
//   type: 'setManagerList',
//   payload: e,
// });

// export const setMemberList = (e) => ({
//   type: 'setMemberList',
//   payload: e,
// });

// export const setSelectedMemberList = (e) => ({
//   type: 'setSelectedMemberList',
//   payload: e,
// });

// export const setServiceList = (e) => ({
//   type: 'setServiceList',
//   payload: e,
// });

// export const setAssignList = (e) => ({
//   type: 'setAssignList',
//   payload: e,
// });

export const reset4SignIn  = (e) => ({
  type: 'reset4SignIn',
  payload: e,
});